import { DynamicCalltrackingContext } from '@cian/frontend-dynamic-calltracking-component';
import * as React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { PageContainer } from 'shared/containers/PageContainer';

import { IState } from '../../store';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../ApplicationContext';

interface IApplicationContainerProps {
  context: IApplicationContext;
  reduxStore: Store<IState>;
}

export const ApplicationContainer: React.FC<IApplicationContainerProps> = ({ context, reduxStore }) => {
  const { httpApi, logger } = context;

  return (
    <Provider store={reduxStore}>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <DynamicCalltrackingContext.Provider value={{ httpApi, logger }}>
        <ApplicationContext.Provider value={context}>
          <PageContainer />
        </ApplicationContext.Provider>
      </DynamicCalltrackingContext.Provider>
    </Provider>
  );
};
